import React from 'react'; 
import Model from './model';
import ViewApp from './viewsasset';
import Show from './show';
import i18n from 'i18next';


/** Ищет идентификатор viewId */
function getRecommendedViewId(location) {
  if (location && location.search){
    const searchParams = new URLSearchParams(location.search);
    return {id: searchParams.get('view')};
  }
  return {};
}
//Специальная компонента proxy, которая показывает:
// 1. либо список представления
// 2. либо предствление (если оно одно из списка)
class ViewsProxy extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: true, 			  //Флаг загрузки, список views или элементарного view
      operation: "views",   //Текущая операция views - отобразить список представлений, view - отобразить одно представление
      asset: undefined,     //Текущие параметры ассета, для получения списка ассетов
      view: undefined,      //Текущие параметры представления, для его отображения
      show: undefined,      //Описание представления, которое должно быть загружено
    }
		this.model = new Model(this.props.rpc_url) 
		this.model.setLoadListener(this);
  }

  static getDerivedStateFromProps(props, state) {
    if ((JSON.stringify(props.asset)!= JSON.stringify(state.asset)) || (JSON.stringify(props.view)!= JSON.stringify(state.view))){
      return {loading: true, operation: "empty", asset: props.asset, view: props.view, show: undefined};
    }
    return null;
  }

	componentDidMount(){
    const {view} = this.props;
    if (this.state.loading && view && (this.state.operation == "empty")){
      this.model.getView(view.id)
        .then(response => {
          //console.log("ViewsProxy.js componentDidMount()", response)
          this.setState({loading: false, operation: "view", show: response.view});
      })  
      return;
    }
    if (this.state.loading && (this.state.operation == "empty"))
      this.setState({loading: false, operation: "views", show: undefined});
	}

  componentDidUpdate(prevProps, prevState) {
    const {view} = this.props;
    if (this.state.loading && view && (this.state.operation == "empty")){
      this.model.getView(view.id)
        .then(response => {
          //console.log("ViewsProxy.js componentDidUpdate(prevProps, prevState)", response)
          this.setState({loading: false, operation: "view", show: response.view});
      })  
      return;
    }
    if (this.state.loading && (this.state.operation == "empty"))
      this.setState({loading: false, operation: "views", show: undefined});
  }

	loadStart(){
		//this.setState({loading: true, operation: "loading"})
	}
	loadDone(){
		//this.setState({loading: false})
	}
	loadError(error){
		alert(i18n.t('app.error') + '\n' + error.message + '\n' + error.debug);
		//this.setState({loading: false})
	}

  render() {
    const { asset, filter } = this.props;
    const { operation } = this.state;
    const isLoading = this.state.loading// || true
    //console.log(this);
    return (
			<span>
				{(isLoading) && (<div className="loading-overlay"></div>)}
        {(!isLoading && (operation == "views")) && <ViewApp rpc_url={this.props.rpc_url} asset={asset} enabled={filter} showView={getRecommendedViewId(this.props.location)} />}
        {(!isLoading && (operation == "view")) && (<div className="setup-view-app"><Show model = {this.model}  view={this.state.show} /></div>)}
			</span>
    )
  }
}

export default ViewsProxy;